import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../redux/hooks";
import { formatCurrency } from "../../../utils/formatNumber";
import { useDateFormatter } from "../../../i18n/useDateFormatter";
import { createAppColumnHelper, useClientTable } from "../../../components/table/tableFeatures";
import { Table } from "../../../components/table/Table";

const columnHelper = createAppColumnHelper();

const FlightsTable = ({ data }) => {
  const { t } = useTranslation(["dsp"]);
  const { marketPlace } = useAppSelector((state) => state.marketPlace);
  const dateFormatter = useDateFormatter("medium");

  const columns = useMemo(() => {
    const formatDate = (value) => (value ? dateFormatter.format(new Date(value)) : "-");
    return [
      columnHelper.accessor("startDateTime", {
        header: t(($) => $.dsp["Start Date"]),
        size: 130,
        enableResizing: false,
        cell: ({ getValue }) => formatDate(getValue()),
      }),
      columnHelper.accessor("endDateTime", {
        header: t(($) => $.dsp["End Date"]),
        size: 130,
        enableResizing: false,
        cell: ({ getValue }) => formatDate(getValue()),
      }),
      columnHelper.accessor("budgetAmount", {
        header: t(($) => $.dsp["Budget"]),
        size: 120,
        enableResizing: false,
        meta: { justify: "end" },
        cell: ({ getValue }) => formatCurrency(getValue(), { marketPlace }),
      }),
    ];
  }, [t, marketPlace, dateFormatter]);

  const table = useClientTable({
    data,
    columns,
    initialState: { sorting: [{ id: "startDateTime", desc: false }] },
  });

  return <Table table={table} />;
};

export default FlightsTable;
